import { createReducer } from '@reduxjs/toolkit';
import { Reducer } from 'redux';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { dates } from '@/utils/constants';

import { CalendarNavigationActions, CalendarNavigationState, rulerDateRangeSet } from './calendar-navigation.actions';

dayjs.extend(utc);

const initialRulerRange: [string, string] = [
    dates.today.startOf('day').format(dates.format),
    dates.today.endOf('day').format(dates.format),
];

const _initialState: CalendarNavigationState = {
    rulerDateRange: initialRulerRange,
};

const initialState: CalendarNavigationState = Object.assign({}, _initialState);

export const calendarNavigationReducer: Reducer<CalendarNavigationState, CalendarNavigationActions> = createReducer(
    initialState,
    (builder) => {
        builder.addCase(
            rulerDateRangeSet,
            (state: CalendarNavigationState, action: ReturnType<typeof rulerDateRangeSet>) =>
                Object.assign<object, CalendarNavigationState, Partial<CalendarNavigationState>>({}, state, {
                    rulerDateRange: action.payload,
                }),
        );
    },
);
